import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";
import ApplicationList from "../Components/ApplicationsList";
import ButtonBack from "../Components/ButtonBack";
import SearchInput from "../Components/SearchInput";

class ApplicationsListPage extends Component {
    onAddClicked() {
        const { stores } = this.props;

        let newApplication = stores.data.ApplicationsStore.add();

        const hash = `#application-detail?id=` + newApplication.Id;
        window.location.hash = hash;
    }

    render() {
        const { stores } = this.props;
        const { search } = stores.ui.view.parameters;

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Applications</h1>
                </div>

                <div className="row">
                    <div className="pull-left">
                        <SearchInput />
                    </div>
                    <div className="pull-right">
                        <Button
                            type="button"
                            bsStyle="success"
                            onClick={this.onAddClicked.bind(this)}
                        >
                            <Glyphicon glyph="plus" />
                            <span>Add</span>
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <ApplicationList applicationsStore={stores.data.ApplicationsStore} filter={search} />
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(ApplicationsListPage));



// WEBPACK FOOTER //
// ./src/Pages/ApplicationsListPage.js